<template>
  <div>

  </div>
  <div class="text-center small noselect">
    <span @click="prevWeek()" :class="{disable:!viewPrew}"><span class="icon prev"></span></span> <span
      @click="nextWeek()"><span class="icon next"></span></span>
  </div>
  <div  class="text-center small mt-2" v-if="!spinerView">
    <small>Режим работы: с {{getOfficeWorkTimeStart}} до {{getOfficeWorkTimeEnd}}</small>
  </div>
  <div class="booking-table my-4" :class="getXClass">
  <span v-if="spinerView" class="spinner-border spinner-border-sm text-primary position-absolute"
        style="top:50%; left: 50%; z-index: 9999"></span>

    <template v-if="!spinerView && this.$store.state.vModeWeek == 0 ">
      <div class="date-wrapper sticky">
        <div class="left-column"></div>
        <div class="date-line">
          <CabCardMobile
              v-for="(date) in getDates"
              v-bind:key="date"
              v-bind:date="date"
          />

        </div>
      </div>
      <div class="booking-box">
        <div class="left-column ">
          <TimeLineMobile v-bind:startTime="getOfficeWorkTimeStart" v-bind:endTime="getOfficeWorkTimeEnd"/>
        </div>
        <div class="booking-pills vertical">
          <BTWallCellsMobile
              v-for="(date) in getDates"
              v-bind:key="date"
              v-bind:date="date"
              v-bind:priceData="getPriceData(date)"
              v-bind:startTime="getOfficeWorkTimeStart" v-bind:endTime="getOfficeWorkTimeEnd"
              v-bind:timeZone = "getOfficeTimezone"
          />
        </div>
      </div>
    </template>
    <template v-if="!spinerView && this.$store.state.vModeWeek == 1 ">
      <div class="sticky">
        <div class="wrapper-scroll sync-scroll-cabinet date-wrapper horizontal ">
          <div class="left-column _vertical"></div>
          <div class="date-line">
            <TimeLineMobile v-bind:startTime="getOfficeWorkTimeStart" v-bind:endTime="getOfficeWorkTimeEnd"/>
          </div>
        </div>
      </div>
      <div class="booking-box">
        <div class="left-column _vertical">
          <CabCardMobile
              v-for="(date) in getDates"
              v-bind:key="date"
              v-bind:date="date"

          />
        </div>
        <div class="booking-pills horizontal wrapper-scroll sync-scroll-pills">
          <BTWallCellsMobile
              v-for="(date) in getDates"
              v-bind:key="date"
              v-bind:date="date"
              v-bind:priceData="getPriceData(date)"
              v-bind:startTime="getOfficeWorkTimeStart" v-bind:endTime="getOfficeWorkTimeEnd"
              v-bind:timeZone = "getOfficeTimezone"
          />
        </div>
      </div>
    </template>
  </div>

</template>
<style>

</style>
<style scoped>
.wrapper-scroll {
  overflow: hidden;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.wrapper-scroll::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.wrapper-scroll .scroll-y {
  display: none !important;
}
.sticky{
  position: sticky;
  top: 0px;
  width: 100%;
  z-index: 2000;
}

.booking-table {
  position: relative;
  container-name: booking-table-container;
  container-type: inline-size;
}
.booking-pills{
  display: flex;
  width: 100%;
  container-name: booking-pills-container;
  container-type: inline-size;
}
.booking-pills.horizontal{
  max-width: 100%;
  overflow: hidden;
  overflow-x: auto;
  flex-direction: column;
}
.booking-pills.vertical{
  //flex-direction: column;
  flex-direction: row;

}
.left-column {
  display: flex;
  width: calc(100% / 8);
  min-width: calc(100% / 8);
  container-type: inline-size;
  flex-direction: column;
  container-name: left-column-container;
  container-type: inline-size;
  align-items: center;
  justify-content: center;
}


.xsize-1 .left-column._vertical{
  width: 2.5rem;
  min-width: 2.5rem;

}

.xsize-2  .left-column._vertical{
  width: 3rem;
  min-width: 3rem;

}

.xsize-3  .left-column._vertical{
  width: 4rem;
  min-width: 4rem;

}


.date-line{
  display: flex;
  width: 100%;
}

.booking-box {
  display: flex;
  position: relative;
  flex-direction: row;

}

.date-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.date-wrapper.horizontal{
  width: 100%;
  overflow: hidden;
  overflow-x: auto;
}
.disable {
  opacity: .1;
}
.icon {
  position: relative;
  display: inline-block;
  width: 1.2rem;
  height: 1.2rem;
  background-repeat: no-repeat;
  background-position: bottom;
  position: relative;
  top: 4px;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color ease .4s;
}

.icon:hover {
  background: #ffdec0;
}

.icon.next {

  margin-left: .5rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23e07a5f' class='bi bi-arrow-right-circle' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z'/%3E%3C/svg%3E");
}

.icon.prev {
  margin-right: .5rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23e07a5f' class='bi bi-arrow-left-circle' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z'/%3E%3C/svg%3E");
}
</style>
<script>

import {dateFormat} from "@/dateFormat";
import TimeLineMobile from "@/components/BookingTableMobile/TimeLineMobile.vue";
import CabCardMobile from "@/components/BookingTableMobile/CabCardMobile.vue";
import BTWallCellsMobile from "@/components/BookingTableMobile/BTWallCellsMobile.vue";


export default {
  components: { BTWallCellsMobile, CabCardMobile, TimeLineMobile},
  props: {
    officeId: Number
  },
  inject: ['searchData'],
  provide() {
    // use function syntax so that we can access `this`
    return {
      viewPrew: false,
      officeId: Number(this.officeId),
      selectData: this.getSelectData,
      mySelectData: this.getMySelectData,
      errorData: this.getErorrData
    }
  },
  name: 'BookingTableMobile',
  data() {
    return {
      // daysTitle:[
      //     'воскресенье',
      //     'понедельник',
      //     'вторник',
      //     'среда',
      //     'четверг',
      //     'пятница',
      //     'суббота'
      // ],
      viewPrew: false,
      spinerView: true,
      // keyposfix: 1
      speed: 1, // Скорость скролла.
      left: 0, //нажали мышку - сохраняем положение скролла
      drag: false,
      coorX: 0 // нажали мышку - сохраняем координаты.
    }
  },
  mounted() {

    this.scrollInit()
  },
  updated() {

    this.scrollInit()
  },
  watch: {

    'searchData.date'(val) {
      let nowDate = dateFormat.formatDate(dateFormat.getDateNowWithTimeZone())
      if (dateFormat.compare(val, nowDate) == '>') {
        // console.log(val)
        this.viewPrew = true
      } else {
        // console.log(val)
        this.viewPrew = false
      }

    },
    '$store.state.data': {

      handler() {
        // console.log('WATCH')
        this.spinerView = false;
      },
      deep: true
    }

    // '$store.state.date'(val){
    //   let nowDate = dateFormat.formatDate(dateFormat.getDateNowWithTimeZone())
    //   if(dateFormat.compare(val,nowDate) == '>'){
    //     // console.log('ALEX','VIEW')
    //     this.viewPrew = true
    //   }else{
    //     // console.log('ALEX','NOW')
    //     this.viewPrew = false
    //   }
    //
    // }
  },
  computed: {
    getOfficeTimezone() {
      return this.$store.state.data.cabinet['timeZone']
    },
    getOfficeWorkTimeStart(){
      return this.$store.state.data.cabinet['workTimeStart']
    },
    getOfficeWorkTimeEnd(){
      return this.$store.state.data.cabinet['workTimeEnd']
    },
    getXClass() {
      return 'xsize-' + this.$store.state.xWeek;
    },
    dateFormat() {
      return dateFormat.strToFormat(this.$store.state.date)
    },
    dateFormatDay() {
      let date = new Date(this.$store.state.date)
      let dayNum = date.getDay()
      return this.daysTitle[dayNum]
    },
    getCalcKey() {
      return this.calcKey;
    },
    getErorrData() {
      return this.$store.state.selector.error
    },
    getSelectData() {
      return this.$store.state.selector.new
    },
    getMySelectData() {
      return this.$store.state.selector.my
    },
    getOfficeTitle() {
      return this.$store.state.office.data[this.officeId]['title']
    },
    getOfficeUrl() {
      return '/places/' + this.$store.state.office.data[this.officeId]['url_alias']
    },
    // getCabinetsTimeRange(){
    //     return this.calcTimeRange()
    // },
    getDates() {
      // return this.$store.state.loading ? ["2023-05-01","2023-05-02","2023-05-03","2023-05-04","2023-05-05","2023-05-06","2023-05-07"] : this.$store.state.data.dates
      return this.$store.state.data.dates
    },
    getCabinetsPrices() {
      // console.log(this.$store.state.cabinet.data.cabinetsPrices[this.officeId])

      return this.$store.state.data.prices
    },
  },
  methods: {
    prevWeek() {
      this.$emitter.emit('prevWeek')
    },
    nextWeek() {
      this.$emitter.emit('nextWeek')
    },
    getPriceData: function (dt) {
      let date = new Date(dt)
      let dayNum = date.getDay()
      let type = dayNum == 0 || dayNum == 6 ? 'weekend' : 'weekdays'
      return this.$store.state.data.prices[type]
    },
    prevDate() {
      this.$emitter.emit('prevDate')
    },
    nextDate() {
      this.$emitter.emit('nextDate')
    },
    mousedown(e) {
      let el = e.currentTarget;
      this.drag = true
      this.coorX = e.pageX - el.offsetLeft;
      this.left = el.scrollLeft;
    },
    mouseup() {
      this.drag = false
    },
    mouseMove(e) {
      if (this.drag) {
        let el = e.currentTarget;
        let scroll = this.left - (e.pageX - el.offsetLeft - this.coorX) * this.speed;

        el.scrollLeft = scroll;
      }
    },
    scroll_t1(e){
      let parent = e.currentTarget.closest('.booking-table');
      if (parent) {
        let syncscroll = parent.querySelector('.wrapper-scroll.sync-scroll-pills');
        syncscroll.scrollLeft = e.currentTarget.scrollLeft
      }
    },
    scroll_t2(e){
      let parent = e.currentTarget.closest('.booking-table');
      if (parent) {
        let syncscroll = parent.querySelector('.wrapper-scroll.sync-scroll-cabinet');
        syncscroll.scrollLeft = e.currentTarget.scrollLeft
      }
    },
    scrollInit() {
      //синхронизация скроллинга линии кабинетов и броней
      if (this.$store.state.vModeWeek == 1 ){
        let tableAll = document.querySelectorAll('.booking-table');
        for (let table of tableAll){

          var syncScrollCabinet = table.querySelector('.wrapper-scroll.sync-scroll-cabinet');
          var syncScrollPills = table.querySelector('.wrapper-scroll.sync-scroll-pills');

          syncScrollCabinet.removeEventListener("scroll", this.scroll_t1);
          syncScrollCabinet.addEventListener('scroll', this.scroll_t1);
          syncScrollPills.removeEventListener("scroll", this.scroll_t2);
          syncScrollPills.addEventListener('scroll', this.scroll_t2);
        }
      }
    },
  }
}
</script>

